import React from "react";

const LoadingScreen = ({ loadingText }) => (
  <div className="min-vh-100 d-flex justify-content-center align-items-center bg-light">
    <div className="text-center">
      <div
        className="spinner-border text-primary mb-3"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-muted">{loadingText}</p>
    </div>
  </div>
);

export default LoadingScreen;
